import React from 'react';
import { Users, UserCircle, Clock } from 'lucide-react';
import { DonutChart } from './DonutChart';
import { StatCard } from './StatCard';
import { StatSection } from './StatSection';

interface GeneralStatsProps {
  totalMembers: number;
  genderStats: {
    hombres: number;
    mujeres: number;
  };
  ageStats: {
    menoresDeEdad: number;
    mayoresDeEdad: number;
  };
}

export const GeneralStats: React.FC<GeneralStatsProps> = ({
  totalMembers,
  genderStats,
  ageStats
}) => {
  return (
    <div className="space-y-6">
      {/* Cards de resumen */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatCard
          title="Total de Miembros"
          value={totalMembers}
          icon={<Users className="w-6 h-6" />}
          color="purple"
          subtitle="Miembros registrados"
        />
        <StatCard
          title="Hombres"
          value={genderStats.hombres}
          icon={<UserCircle className="w-6 h-6" />}
          color="blue"
          subtitle={`${((genderStats.hombres / Math.max(totalMembers, 1)) * 100).toFixed(1)}% del total`}
        />
        <StatCard
          title="Mujeres"
          value={genderStats.mujeres}
          icon={<UserCircle className="w-6 h-6" />}
          color="pink"
          subtitle={`${((genderStats.mujeres / Math.max(totalMembers, 1)) * 100).toFixed(1)}% del total`}
        />
      </div>

      {/* Gráficos */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <StatSection title="Distribución por Género" icon={UserCircle} iconColor="text-blue-600">
          <div className="flex flex-col items-center">
            <DonutChart
              data={[
                { label: 'Hombres', value: genderStats.hombres, color: '#3b82f6' },
                { label: 'Mujeres', value: genderStats.mujeres, color: '#ec4899' }
              ]}
              centerText={totalMembers.toString()}
              centerSubtext="Total"
            />
            <div className="flex justify-center space-x-6 mt-4">
              <div className="flex items-center">
                <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                <span className="text-xs text-gray-600">Hombres: {genderStats.hombres}</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-pink-500 rounded-full mr-2"></div>
                <span className="text-xs text-gray-600">Mujeres: {genderStats.mujeres}</span>
              </div>
            </div>
          </div>
        </StatSection>

        <StatSection title="Distribución por Edad" icon={Clock} iconColor="text-green-600">
          <div className="flex flex-col items-center">
            <DonutChart
              data={[
                { label: 'Mayores de edad', value: ageStats.mayoresDeEdad, color: '#10b981' },
                { label: 'Menores de edad', value: ageStats.menoresDeEdad, color: '#f59e0b' }
              ]}
              centerText={totalMembers.toString()}
              centerSubtext="Total"
            />
            <div className="flex justify-center space-x-6 mt-4">
              <div className="flex items-center">
                <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                <span className="text-xs text-gray-600">Mayores: {ageStats.mayoresDeEdad}</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-yellow-500 rounded-full mr-2"></div>
                <span className="text-xs text-gray-600">Menores: {ageStats.menoresDeEdad}</span>
              </div>
            </div>
          </div>
        </StatSection>
      </div>
    </div>
  );
};

export default GeneralStats;
